import { Helmet as ReactHelmet } from 'react-helmet';

interface HelmetProps {
  title: string;
}

export const Helmet = ({ title }: HelmetProps) => (
  <ReactHelmet titleTemplate="SEEK - %s" title={title} />
);
